const isDataUri = uri => !!uri && uri.indexOf('data:') === 0;

export default isDataUri;
